import styled from 'styled-components';
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';

export const PresentationContainer = styled.div`
    display: flex; 
    position: relative; 

    @media screen and (max-width: 768px){
        padding: 100px 0; 
        display: flex; 
        text-align: center; 
    }


    :before{
        content: ''; 
        position: absolute; 
        top: 0; 
        left: 0; 
        right: 0; 
        bottom: 0; 
        background: linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%), 
        linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 100%);
        z-index: 2; 
    }

`;

export const PresentationWrapper = styled.div`
    display: grid; 
    z-index: 9; 
    height: 860px; 
    width: 100%; 
    max-width: 1100px; 
    margin-right: auto; 
    margin-left: auto; 
    padding: 0 24px; 
    justify-content: center; 
`;

export const PresentationRow = styled.div`
    display: grid; 
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center; 
    grid-template-areas:  'col1 col2'; 
    align-items: center;

    @media screen and (max-width: 768px){
        grid-template-areas:  'col1 col1' 'col2 col2'; 
    }
`;

export const Column1 = styled.div`
    margin-bottom: 15px; 
    padding: 0 15px; 
    grid-area: col1; 
`;

export const Column2 = styled.div`
    margin-bottom: 15px; 
    padding: 0 15px; 
    grid-area: col2; 
    justify-content: center;
    display: flex;

    @media screen and (max-width: 768px){
        justify-content: center;
        display: flex;
    }
    
`;

export const TextWrapper = styled.div`
    max-width: 540px; 
    padding-top: 0; 
    padding-bottom: 60px; 
    
`;

export const TopLine = styled.p`
    font-size: 16px; 
    line-height: 16px; 
    font-weight: 700; 
    letter-spacing: 1.4px; 
    text-transform: uppercase; 
    margin-bottom: 16px; 
`;

export const Heading = styled.h1`
    margin-bottom: 24px; 
    font-size: 48px; 
    line-height: 1.1;
    font-weight: 600; 

    @media screen and (max-width: 480px){
        font-size: 32px;
    }
`;

export const Subtitle = styled.p`
    max-width: 440px; 
    margin-bottom: 35px; 
    font-size: 18px; 
    line-height: 24px; 

    @media screen and (max-width: 768px){
        
    }
`;

export const ImgWrap = styled.div`
    overflow: hidden;
    width: 365px;
    height: 365px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 250px;
    -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
    filter: grayscale(100%); /* Firefox */

    &:hover {
        -webkit-filter: grayscale(0%); /* Chrome, Safari, Opera */
        filter: grayscale(0%); /* Firefox */
    }

    @media screen and (max-width: 768px){
       
    }
`;

export const Img = styled.img`
    width: 100%; 
    margin: 0 0 10px 0; 
    padding-right: 0; 
`;


export const PresentationBg = styled.div`
    position: absolute; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    width: 100%; 
    height: 100%; 
    overflow: hidden; 
`;

export const VideoBg = styled.video`
    width: 100%; 
    height: 100%; 
    --o-object-fit: cover; 
    object-fit: cover; 
`;

export const PresentationBtnWrapper = styled.div`
    margin-top: 32px; 
    display: flex; 
    flex-direction: column; 
    align-items: flex-start;

    @media screen and (max-width: 768px){
        align-items: center;
    }
`;

export const ArrowForward = styled(MdArrowForward)`
    margin-left: 8px; 
    font-size: 20px; 
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px; 
    font-size: 20px; 
`;

